// Base API URL
const BASE_URL = "https://xx8m9tf0m8.execute-api.ap-south-1.amazonaws.com/dev";

// API Key for backend authentication
const API_KEY = "iQTrpKUhYrPpegupyhME2IxTDUQ50tV4Za5sx6yj";

export const API = {
  submitArticle: `${BASE_URL}/submissions`,
  getUploadUrl: `${BASE_URL}/submissions/upload-url`,
  getDownloadUrl: `${BASE_URL}/submissions/download-url`,

  // Contact form endpoints
  submitContact: `${BASE_URL}/contact`,
};

// API Key for authentication
export const API_KEY_HEADERS = {
  "x-api-key": API_KEY,
  "Content-Type": "application/json",
};

// Default export
export default API;
